import { Alert, Snackbar } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'src/redux-app-hooks';
import { hideSnackbar, NotificationSeverity } from './notifications.slice';

const NOTIFICATION_HIDE_DURATION_MS = 8000;

export default function NotificationSnackbar() {
    const snackbar = useAppSelector((state) => state.notifications.snackbar);
    const dispatch = useAppDispatch();

    const mapColor = (severity: NotificationSeverity) => {
        switch (severity) {
            case NotificationSeverity.Info:
                return 'info';
            case NotificationSeverity.Success:
                return 'success';
            case NotificationSeverity.Warning:
                return 'warning';
            case NotificationSeverity.Error:
                return 'error';
            default:
                throw new Error('unknown severity');
        }
    };

    const color = mapColor(snackbar?.severity ?? NotificationSeverity.Info);

    return (
        <Snackbar
            open={snackbar !== null}
            onClose={() => dispatch(hideSnackbar())}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={NOTIFICATION_HIDE_DURATION_MS}
        >
            <Alert severity={color} variant="filled" sx={{ width: '100%' }} onClose={() => dispatch(hideSnackbar())}>
                {snackbar?.message}
            </Alert>
        </Snackbar>
    );
}
